import { GLProgram } from "../../../program.js";
export class BrushProgram extends GLProgram {

    constructor(gl: any, vertex_source: any, fragment_source: any) {
        super(gl, vertex_source, fragment_source);
    }

    static create(templates, gl) {
        var vertex_source = templates.get('photoshop/GL/shaders/tools/brush/vertex.glsl');
        var fragment_source = templates.get('photoshop/GL/shaders/tools/brush/fragment.glsl');
        var result = new BrushProgram(gl, vertex_source, fragment_source);
        result._uniforms['texture'] = gl.getUniformLocation(result._program, 'u_texture');
        result._uniforms['background'] = gl.getUniformLocation(result._program, 'u_background');
        result._uniforms['use_background'] = gl.getUniformLocation(result._program, 'u_use_background');
        result._uniforms['stroke_mask'] = gl.getUniformLocation(result._program, 'u_stroke_mask');
        result._uniforms['color'] = gl.getUniformLocation(result._program, 'u_color');
        return result;
    }

    setUniforms(parameters) {
        var self = this;
        self._gl.uniform4fv(self.uniformLocation('color'), parameters.color);
    }

}